import { CSSProperties, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useEffectOnce, useMeasure } from 'react-use';

import { headerLogo } from 'assets/images';

import { ROUTE_DASHBOARD } from '../constants/routes';
import { coreGetLoginPage, coreSetHeaderHeight } from '../actions/coreActions';
import { NavBar } from './NavBar';
import styles from './Header.module.scss';
import { getCoreHeight, getCoreLoginPageUrl } from '../selectors/coreSelectors';
import { IRootState } from '../interfaces/IRootState';

interface IHeaderBaseProps {
  style?: CSSProperties;
}

interface IHeaderBaseStoreProps {
  headerHeight: number;
  loginPageUrl?: string;
}

const HeaderBase = ({ style, headerHeight, loginPageUrl }: IHeaderBaseProps & IHeaderBaseStoreProps) => {
  const [ref, { height }] = useMeasure<HTMLDivElement>();
  const dispatch = useDispatch();
  useEffectOnce(() => {
    dispatch(coreGetLoginPage());
  });

  useEffect(() => {
    // document.body.style.paddingTop = `${height}px`;
    // document.getElementById('root').style.height = `calc(100vh - ${height}px)`;
    if (height !== headerHeight) {
      dispatch(coreSetHeaderHeight(height));
    }
  }, [height, dispatch, headerHeight]);

  const onScroll = () => {
    const windowOffset = window.scrollY;
    const headerElement = document.querySelector('header');
    if (headerElement && windowOffset > headerElement.offsetHeight) {
      headerElement.setAttribute('data-scroll', 'true');
    } else if (!windowOffset) {
      headerElement?.setAttribute('data-scroll', 'false');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <header ref={ref} className={styles.header} data-scroll="false" style={style}>
      <div className={styles.HeaderLogo}>
        <Link to={ROUTE_DASHBOARD} className={styles.LogoBlock}>
          <img className={styles.LogoImg} alt="Генеральная прокуратура Российской Федерации" src={headerLogo} />
          <div className={styles.Titles}>
            <h3 className={styles.h3}>Генеральная прокуратура Российской Федерации</h3>
            <h5 className={styles.Title}>ФГИС «Единый реестр контрольных (надзорных) мероприятий»</h5>
            <h5 className={styles.Title}>ФГИС «Единый реестр проверок»</h5>
          </div>
        </Link>
        <a href={loginPageUrl} className={styles.SignInLink}>
          Войти
        </a>
      </div>
      <NavBar />
    </header>
  );
};

const mapStateToProps = (state: IRootState): IHeaderBaseStoreProps => ({
  headerHeight: getCoreHeight(state),
  loginPageUrl: getCoreLoginPageUrl(state),
});

export const Header = connect(mapStateToProps)(HeaderBase);
